<template>
     <!-- Footer Start -->
     <div class="container-fluid pt-5 mt-5 px-4 mt-2" style="position:absolute; bottom:0;">
        <div class="bg-light rounded-top p-4">
            <div class="row">
                <div class="col-12 col-sm-12 text-sm-start">
                    &copy; 2025 - <a href="https://zode-ht.com/" target="_blank" >ZODE</a> | Tous droits réservés 
                </div>
            </div>
        </div>
    </div>
    <!-- Footer End -->
</template>

<script>
    export default {
        name:"FooterView"
    }
</script>

<style scoped>

</style>